import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

import { DeletePostDocument } from './Event.mutation.generated';

export const useEventDeletePost = () => {
  const [call, status] = useMutation(DeletePostDocument, {
    update: (cache, res) => {
      const postId = res.data?.delete_lives_post_by_pk?.id;

      if (postId) {
        cache.writeFragment({
          id: `lives_post:${postId}`,
          fragment: gql`
            fragment DeletePost on lives_post {
              deleted @client
            }
          `,
          data: {
            deleted: true,
          },
        });
      }
    },
  });

  return { call, status };
};
